export default __webpack_public_path__ + "static/media/biacharm2.33f341e5.jpg";